import { AppCard, AppUseIcon } from 'components/ui';

import { AppButton } from 'components/form';
import { AppLinks } from 'utilities/Constants';
import ipadImage from 'assets/img/ipad-top3x.png';
import { t } from 'utilities/TranslationUtils';

export const SupportSection = () => {
  const goToTrackmanZendeskHandler = () => {
    window.open(AppLinks.Support, '_blank');
  };

  return (
    <AppCard title={t('support')} className='overflow-hidden'>
      <div className='position-relative h-100'>
        <div className='mb-3'>{t('homePage.SupportText')}</div>
        <AppButton variant='outline-primary' onClick={() => goToTrackmanZendeskHandler()}>
          {t('homePage.SupportButton')} <AppUseIcon name='ExternalLinkIcon' className='ml-2' color='currentColor' width='15' height='15' />
        </AppButton>
        <img className=' object-fit-contain position-absolute bottom-0 right-0' src={ipadImage} alt='' height='100px' />
      </div>
    </AppCard>
  );
};

export default SupportSection;
